import AltusTalk from 'components/altus-talk/altus-talk';
import BackHeader from 'components/back-header/back-header';
import Button from 'components/button/button';
import Flex from 'components/flex/flex';
import Page from 'components/page/page';
import styles from './android-request-permission.module.scss';

export interface AndroidRequestSuccessProps {
  text: string;
  onNext: () => void;
  childrenId: string;
  stepNumber: number;
}

export default function AndroidRequestSuccess({ childrenId, onNext, stepNumber, text }: AndroidRequestSuccessProps) {
  return (
    <Page>
      <div className={styles.grid}>
        <Flex
          direction="column"
          width="100%"
          height="100%"
          align="center"
          style={{ paddingTop: 100, overflowY: 'auto' }}
          gap={8}
          className={styles.test}
        >
          <BackHeader title="Demande de permission" href={`/blocker/${childrenId}`} />
          <div className={styles.title}>Succès de l&apos;étape {stepNumber}</div>
          <AltusTalk width={120} type="confeti">
            {text}
          </AltusTalk>
        </Flex>
        <Flex direction="column" pad={10} width="100%" gap={12}>
          <Button color="primary" onClick={onNext}>
            CONTINUER
          </Button>
        </Flex>
      </div>
    </Page>
  );
}
